import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { checkModelEditable, setModelEditable } from 'store/actions/rpcActions';
import { AvailCanvas } from './AvailCanvas';
import { ModelStatus } from 'pages/ModelStatus';
import { useModelLoader } from 'hooks';
import {
  clearUpdateData,
  clearSerializedData,
  setGuidURL,
  setReinitializeCanvas,
  setExportModel,
  setExportedModelData,
} from 'store/actions/canvasActions';
import { CanvasContainer } from './styles';
import { ActionArea } from './ActionArea';
import constants from 'constants';

const { VIEWER_MODEL_FORMAT } = constants;

const Avail = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const guid = pathname.split('avail/')[1];
  const loader = useModelLoader({ guid, format: VIEWER_MODEL_FORMAT });

  const cleanup = useCallback(() => {
    dispatch(clearUpdateData());
    dispatch(clearSerializedData());
    dispatch(setGuidURL(null));
    dispatch(setReinitializeCanvas(false));
    dispatch(setExportModel(false));
    dispatch(setExportedModelData(null));
    dispatch(setModelEditable(null));
  }, [ dispatch ]);

  useEffect(() => {
    return () => cleanup();
  }, [ cleanup ]);

  useEffect(() => {
    if (guid) dispatch(checkModelEditable({ guid }));
  }, [ guid, dispatch ]);

  if (loader.showStatus) {
    return (
      <CanvasContainer>
        <ModelStatus {...loader.statusProps} />
      </CanvasContainer>
    );
  }

  return (
    <CanvasContainer>
      <AvailCanvas previewURL={loader.previewURL} />
      <ActionArea guidURL={loader.previewURL} guid={guid} />
    </CanvasContainer>
  );
};

export { Avail };
